import Sidebar from 'components/Dashboard/Sidebar'
import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

const DashboardLayout = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div>
            <Sidebar />
            <div className={`content ${isMobile ? "content-mobile" : ""}`}>
                <Outlet />
            </div>
        </div>
    )
}

export default DashboardLayout